export enum WorkspaceStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
